import axios from 'axios'

let CancelToken = axios.CancelToken
export var cancelSource = null

function handleError (error) {
  if (axios.isCancel(error)) {
    console.log('Request cancelled', error.message)
    throw new Error('isCancelled ' + error.message)
  }

  if (error.response && error.response.data && error.response.data.errors) {
    throw new Error(error.response.data.errors.join(','))
  } else {
    throw error
  }
}

function handleAnswer (response, allowedStati, messagePrefix) {
  if (allowedStati.indexOf(response.status) !== -1) {
    return response.data
  } else {
    // console.error('INFO','userService.post', url, response.status, response.data)
    if (response.data && response.data.errors)
      throw new Error(response.data.errors.join(','))
    else
      throw new Error(messagePrefix + ' status: ' + response.status)
  }
}

export async function post (url, params, token) {
  let config = configGenerator(token, false, false)

  cancelSource = CancelToken.source()
  config['cancelToken'] = cancelSource.token

  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

  let data = new window.FormData()
  for (let field in params) {
    if (params.hasOwnProperty(field))
      data.append(field, params[field])
  }

  let response = null
  try {
    response = await axios.post(url, data, config)
    cancelSource = null
  } catch (error) {
    cancelSource = null
    handleError(error)
  }

  return handleAnswer(response, [200, 201], 'Wrong answer for POST: ' + url)
}

export async function get (url, params = {}, token = null, messagePrefix = null) {
  let config = configGenerator(token, true, false)

  cancelSource = CancelToken.source()
  config['cancelToken'] = cancelSource.token

  if (Object.keys(params).length) {
    url += '?' + Object.keys(params).map(key => { return key + '=' + encodeURIComponent(params[key]) }).join('&')
  }

  let response = null
  try {
    response = await axios.get(url, config)
    cancelSource = null
  } catch (error) {
    cancelSource = null
    handleError(error)
  }

  if (!messagePrefix) {messagePrefix = 'Wrong answer for GET: ' + url}
  return handleAnswer(response, [200], messagePrefix)
}

export function configGenerator (token, json = true, basic = false, timeout = 15000) {
  const authorizationMethod = basic ? 'Basic' : 'Bearer'
  const config = {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    timeout: timeout
  }
  if (token) {
    config.headers['Authorization'] = `${authorizationMethod} ${token}`
  }
  if (json) {
    config.headers['Accept'] = 'application/json'
  }

  return config
}
